export { default } from './MainContentHeader';
export * from './types';
